'use client'

import React from 'react'
import { ChevronDown } from 'lucide-react'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/Collapsible'
import { RenderBlocks } from '@/blocks/RenderBlocks'
import type { CollapsibleBlock as BlockProps } from '@/payload-types'

export const CollapsibleBlockClient: React.FC<BlockProps> = ({ triggerLabel, content }) => {
  return (
    <Collapsible>
      <CollapsibleTrigger className="flex w-full items-center justify-between gap-2 rounded-lg border border-slate-200 bg-white px-4 py-3 text-left font-medium text-slate-800 hover:bg-slate-50">
        <span>{triggerLabel}</span>
        {/* Radix's CollapsibleTrigger sets data-state="open"|"closed" on
            its rendered element. Use the parent-state-aware selector to
            rotate the chevron 180° when the panel is expanded. */}
        <ChevronDown className="h-4 w-4 text-slate-500 transition-transform duration-200 [[data-state=open]_&]:rotate-180" />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="px-4 py-4">
          <RenderBlocks blocks={content ?? []} />
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
